module.exports = __webpack_public_path__ + "img/20240603_txt2_01.baa25a95.png";